import { makeAutoObservable, runInAction } from "mobx";
import { api } from "api/API";

// Limits set by an administrator in Admin -> System Settings. Loaded once at
// start-up (and again after an admin saves); the values below are used until
// then and match the server defaults.
class SystemSettingsStore {
  maxUploadSizeMb = 2;
  allowedFileTypes: string[] = ["pdf", "jpg", "jpeg", "png"];
  minPasswordLength = 8;
  loaded = false;

  constructor() {
    makeAutoObservable(this);
  }

  get maxUploadBytes() {
    return this.maxUploadSizeMb * 1024 * 1024;
  }

  get maxUploadLabel() {
    return `${this.maxUploadSizeMb} MB`;
  }

  // For <input type="file" accept=...>
  get acceptAttribute() {
    return this.allowedFileTypes.map((ext) => `.${ext}`).join(",");
  }

  async load() {
    try {
      const res = await api.get("system-settings/public");
      if (res?.status && res.data) {
        runInAction(() => {
          this.maxUploadSizeMb = Number(res.data.maxUploadSizeMb) || this.maxUploadSizeMb;
          if (Array.isArray(res.data.allowedFileTypes) && res.data.allowedFileTypes.length) {
            this.allowedFileTypes = res.data.allowedFileTypes;
          }
          this.minPasswordLength = Number(res.data.minPasswordLength) || this.minPasswordLength;
          this.loaded = true;
        });
      }
    } catch (error) {
      console.warn("Using default system settings", error);
    }
  }
}

const systemSettingsStore = new SystemSettingsStore();
export default systemSettingsStore;
